(() => {
  function element(tag, attributes = {}, text = '') {
    const node = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => {
      if (value === false || value === undefined || value === null || value === '') return;
      if (key === 'className') node.className = value;
      else if (key in node) node[key] = value;
      else node.setAttribute(key, value);
    });
    if (text) node.textContent = text;
    return node;
  }

  function formField(field, formKey) {
    if (field.type === 'heading') return element('h2', { className: 'tenet-form__heading' }, field.label);
    const id = `tenet-${formKey}-${field.name}`;
    const wrapper = element('div', { className: `tenet-form__field${field.width === 50 ? '' : ' tenet-form__field--full'}` });
    if (field.type === 'checkbox') {
      wrapper.classList.add('tenet-form__checkbox');
      const input = element('input', { id, name: field.name, type: 'checkbox', value: 'true', required: Boolean(field.required) });
      const label = element('label', { htmlFor: id }, field.label);
      wrapper.append(input, label);
      return wrapper;
    }
    const label = element('label', { className: 'tenet-form__label', htmlFor: id }, field.label);
    if (field.required) label.append(element('span', { className: 'tenet-form__required', ariaHidden: 'true' }, '*'));
    let input;
    if (field.type === 'textarea') input = element('textarea', { id, name: field.name, required: Boolean(field.required), placeholder: field.placeholder });
    else if (field.type === 'select') {
      input = element('select', { id, name: field.name, required: Boolean(field.required) });
      input.append(element('option', { value: '' }, 'Select…'));
      (field.options || []).forEach((option) => input.append(element('option', { value: option }, option)));
    } else input = element('input', { id, name: field.name, type: field.type, required: Boolean(field.required), placeholder: field.placeholder, accept: field.accept });
    wrapper.append(label, input);
    if (field.help) wrapper.append(element('small', { className: 'tenet-form__help' }, field.help));
    return wrapper;
  }

  async function mount(root) {
    const status = root.querySelector('[data-form-status]');
    try {
      const response = await fetch(root.dataset.schemaUrl, { headers: { accept: 'application/json' } });
      if (!response.ok) throw new Error('schema');
      const schema = await response.json();
      const form = element('form', { className: 'tenet-form__grid', encType: 'multipart/form-data' });
      schema.fields.forEach((field) => form.append(formField(field, schema.key)));
      const honeypot = element('div', { className: 'tenet-form__honeypot', ariaHidden: 'true' });
      honeypot.append(element('label', { htmlFor: `tenet-${schema.key}-company` }, 'Company'), element('input', { id: `tenet-${schema.key}-company`, name: 'company', type: 'text', tabIndex: -1, autoComplete: 'off' }));
      const actions = element('div', { className: 'tenet-form__actions' });
      const button = element('button', { className: 'tenet-form__button', type: 'submit' }, 'Submit');
      actions.append(button);
      form.append(honeypot, actions);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = 'Submitting…';
        status.dataset.state = '';
        let submitted = false;
        try {
          const result = await fetch(root.dataset.submitUrl, { method: 'POST', body: new FormData(form), headers: { accept: 'application/json' } });
          const payload = await result.json().catch(() => ({}));
          if (!result.ok || !payload.ok) throw new Error(payload.field ? `Please check ${payload.field.replaceAll('_', ' ')}.` : 'Submission failed.');
          submitted = true;
          form.reset();
          form.hidden = true;
          status.replaceChildren(
            element('span', { className: 'tenet-form__success-mark', ariaHidden: 'true' }, '✓'),
            element('span', { className: 'tenet-form__success-title' }, 'Thank you — your form was submitted.'),
            element('span', { className: 'tenet-form__success-copy' }, 'We’ve received your submission and will be in touch soon. Please don’t submit it again unless you need to correct something.')
          );
          status.dataset.state = 'success';
          status.tabIndex = -1;
          status.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          status.focus({ preventScroll: true });
        } catch (error) {
          status.textContent = error.message || 'We could not submit the form. Please try again or email support@ridetenet.com.'; status.dataset.state = 'error';
        } finally {
          form.removeAttribute('aria-busy');
          if (!submitted) button.disabled = false;
        }
      });
      status.textContent = ''; root.append(form);
    } catch { status.textContent = 'This form is temporarily unavailable. Please email support@ridetenet.com.'; status.dataset.state = 'error'; }
  }
  document.querySelectorAll('[data-tenet-form]').forEach(mount);
})();
